const messages = {
    menuTitle: 'Zamówienia',
    pageTitle: 'Zamówienia',
    ecommerce: {
        menuTitle: 'eCommerce',
        pageTitle: 'Zamówienia / Zamówienia eCommerce',
        orderPageTitle: 'Zamówienia / Zamówienia eCommerce / Zamówienie',
        list: {
            pageTitle: 'Lista zamówień eCommerce',
            sendToday: 'Wysyłka na dziś',
            showStatus: 'Pokaż status',
            search: 'Szukaj...',
            orderNumber: 'Numer zamówienia',
            productName: 'Nazwa produktu',
            customer: 'Klient',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            amount: 'Nakład',
            status: 'Status',
            actions: 'Akcje',
            overdue: 'Opóźnione',
            open: 'Otwórz',
            cancel: 'Anuluj',
            cancelOrderTitle: 'Anulowanie zamówienia',
            cancelOrderContent: 'Czy na pewno chcesz anulować zamówienie?',
            confirm: 'Potwierdź'
        },
        order: {
            backToList: 'POWRÓT DO LISTY',
            orderTitle: 'Zamówienie',
            overdue: 'opóźnione',
            orderParameters: 'Parametry zamówienia',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            plannedDeliveryDate: 'Planowana data dostawy',
            receiveFileDate: 'Data dostarczenia plików',
            orderComments: 'Uwagi do zamówienia',
            clear: 'Wyczyść',
            save: 'Zapisz',
            products: 'Produkty',
            productName: 'Nazwa produktu',
            productionFiles: 'Pliki produkcyjne',
            amount: 'Nakład',
            numberOfVersions: 'Ilość wzorów',
            unit: 'szt.',
            shippingAddresses: 'Adresy do wysyłki',
            address: 'Adres',
            weight: 'Waga przesyłki',
            parcels: 'Ilość kartonów',
            sendings: 'Wysyłki',
            editAddress: 'Edytuj adres',
            editParcels: 'Edytuj kartony',
            pattern: 'Wzór',
            filePreview: 'Podgląd plików',
            patternTab: 'WZÓR',
            productionFilesButton: 'Pliki produkcyjne',
            comments: 'Komentarze do zamówienia',
            noComments: 'Brak komentarzy do zamówienia.',
            addComment: 'Dodaj komentarz',
            sendComment: 'Wyślij',
            close: 'Zamknij'
        },
        dialogs: {
            delivery: {
                title: 'Edycja adresu',
                companyName: 'Nazwa firmy',
                firstName: 'Imię',
                lastName: 'Nazwisko',
                street: 'Ulica',
                zipCode: 'Kod pocztowy',
                city: 'Miasto',
                country: 'Kraj',
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            sendings: {
                title: 'Listy przewozowe',
                labelNumber: 'Numer listu przewozowego',
                carrier: 'Metoda wysyłki',
                actions: 'Akcje',
                generatePdf: 'Generuj pdf',
                printZpl: 'Drukuj zpl',
                cancel: 'Anuluj'
            },
            printers: {
                title: 'Drukarki',
                printer: 'Drukarka',
                noPrinterFound: 'Nie znaleziono drukarki',
                selectPrinter: 'Proszę wybrać drukarkę.',
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            parcels: {
                title: 'Edycja kartonów',
                count: 'Ilość kartonów',
                parcelsCount: 'Ilość kartonów',
                parcel: 'Karton',
                kg: 'kg',
                cancel: 'Anuluj',
                save: 'Zapisz',
                errors: {
                    required: 'Pole jest wymagane.',
                    invalidFormat: 'Niepoprawny format.',
                    weightRange: 'Waga powinna zawierać się w przedziale {min} - {max} kg.'
                }
            }
        },
        service: {
            fetchOrdersError: 'Pobranie listy zamówień nie powiodło się.',
            fetchOrderError: 'Pobranie informacji o zamówieniu nie powiodło się.',
            fetchStatusesError: 'Pobranie statusów nie powiodło się.',
            fetchCountriesError: 'Pobranie informacji o możliwych krajach do wysyłki nie powiodło się.',
            fetchPrintersError: 'Pobranie drukarek nie powiodło się.',
            updateOrderError: 'Aktualizacja zamówienia nie powiodła się.',
            addCommentSuccess: 'Dodano komentarz.',
            addCommentError: 'Dodanie komentarza nie powiodło się.',
            updateDeliveryError: 'Edycja dostawy nie powiodła się.',
            toolboxError: 'Błąd komunikacji z Toolboxem.',
            printZPLSuccess: 'ZPL został wydrukowany.',
            printZPLError: 'Wydrukowanie ZPL nie powiodło się.'
        }
    },
    internalOrders: {
        menuTitle: 'Komercyjne',
        pageTitle: 'Zamówienia / Zamówienia komercyjne',
        listPageTitle: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie',
        orderPageTitle: 'Zamówienia / Zamówienia komercyjne / Zamówienie',
        createPageTitle: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie',
        addProductPageTitle: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie / Dodaj produkt',
        editProductPageTitle: 'Zamówienia / Zamówienia komercyjne / Nowe zamówienie / Edycja produktu',
        list: {
            pageTitle: 'Lista zamówień komercyjnych',
            submitOrder: 'Złóż zamówienie',
            filters: {
                status: 'Status',
                search: 'Szukaj po numerze, nazwie',
                customerName: 'Szukaj po kliencie',
                createdBy: 'Tworzący',
                createdFrom: 'Utworzone od',
                createdTo: 'Utworzone do',
                hideClosed: 'Ukryj zamknięte',
                showMine: 'Pokaż moje',
                sendToday: 'Wysyłki na dziś'
            },
            table: {
                productionNumber: 'Numer zamówienia',
                name: 'Nazwa zamówienia',
                customer: 'Klient',
                createdAt: 'Data zamówienia',
                plannedSendDate: 'Planowana data wysyłki',
                numberOfProducts: 'Ilość produktów',
                status: 'Status',
                actions: 'Akcje'
            },
            tooltips: {
                createJob: 'Utwórz zlecenie',
                createJobDisabled: 'Aby utworzyć zlecenie uzupełnij dane zamówienia',
                markClosed: 'Zamknij zamówienie',
                open: 'Otwórz',
                copyOrder: 'Kopiuj zamówienie',
                copyOrderBlocked: 'Zamówienia proof i prototypu opakowania nie można skopiować.',
                delete: 'Usuń',
                overdue: 'Opóźnione'
            },
            dialogs: {
                copyOrderAttachments: {
                    title: 'Kopiowanie załączników',
                    content: 'Czy skopiować załączniki produktów do nowego zamówienia?',
                    yesButton: 'Tak',
                    noButton: 'Nie'
                },
                createJob: {
                    title: 'Tworzenie zlecenia',
                    content: 'Czy na pewno chcesz utworzyć zlecenie?',
                    confirmButton: 'Utwórz'
                },
                markOrderClosed: {
                    title: 'Zmiana statusu',
                    content: 'Czy na pewno chcesz zamknąć to zamówienie?',
                    confirmButton: 'Zatwierdź'
                },
                deleteOrder: {
                    title: 'Usuwanie zamówienia',
                    content: 'Czy na pewno chcesz usunąć zamówienie?',
                    confirmButton: 'Usuń'
                }
            }
        },
        order: {
            titlePrefix: 'Zamówienie',
            backToList: 'Powrót do listy',
            orderParameters: 'Parametry zamówienia',
            orderNumber: 'Numeracja zamówienia',
            name: 'Nazwa zamówienia',
            customer: 'Klient',
            owner: 'Właściciel zamówienia',
            netPrice: 'Cena netto sprzedaży',
            valuation: 'Koszt materiałów',
            plannedSendDate: 'Planowana data wysyłki',
            plannedDeliveryDate: 'Planowana data dostawy',
            receiveMaterialDate: 'Data dostawy surowca',
            receiveFileDate: 'Data dostarczenia plików',
            clear: 'Wyczyść',
            save: 'Zapisz',
            products: 'Produkty',
            comments: 'Uwagi do zamówienia',
            noComments: 'Brak komentarzy do zamówienia.',
            addComment: 'Dodaj komentarz',
            adviceNote: 'Awizacja',
            adviceNoteButton: 'Awizacja od klienta',
            acceptFileDate: 'Data akceptacji plików',
            graphicFileDeliveryMethodLabel: 'Metoda dostarczenia plików graficznych',
            editTooltip: 'Edytuj',
            saveDisabledTooltip: 'Zapisywanie parametrów zamówienia w trakcie migracji.',
            validation: {
                nameRequired: 'Proszę podać nazwę zamówienia.',
                nameMaxLength: 'Nazwa nie może być dłuższa niż 80 znaków',
                nameIllegalChars: 'Niedozwolone znaki – {chars}',
                graphicFileMethodRequiresProductionFiles: 'Metoda wymaga plików produkcyjnych w produktach.'
            },
            sendComment: 'Wyślij',
            statusOverdue: 'opóźnione',
            readOnly: {
                orderType: 'Typ zamówienia:',
                orderName: 'Nazwa zamówienia:',
                customerLabel: 'Klient:',
                ownerLabel: 'Właściciel:',
                netPriceLabel: 'Cena netto sprzedaży:',
                valuationLabel: 'Koszt materiałów:',
                orderDate: 'Data zamówienia:',
                plannedSendDateLabel: 'Planowana data wysyłki:',
                plannedDeliveryDateLabel: 'Planowana data dostawy:',
                receiveMaterialDateLabel: 'Data akceptacji surowca:',
                receiveFileDateLabel: 'Data dostarczenia plików:',
                acceptFileDateLabel: 'Data akceptacji plików:',
                graphicFileDeliveryMethod: 'Metoda dostarczenia plików graficznych:',
                notesLabel: 'Uwagi do zamówienia:',
                deliveryPlan: 'Plan dostaw',
                noDeliveryPlan: 'Nie załączono planu dostaw',
                commentsSection: 'Komentarze do zamówienia'
            },
            productsTable: {
                productName: 'Nazwa produktu',
                productionFile: 'Pliki produkcyjne',
                nettoAmount: 'Nakład',
                extraAmount: 'Naddatek',
                numberOfVersions: 'Ilość wzorów'
            }
        },
        orderCreate: {
            campaignOrder: 'Zamówienie kampanijne',
            numberConfiguration: 'Numeracja zamówienia',
            name: 'Nazwa zamówienia klienta',
            customer: 'Klient',
            owner: 'Właściciel zamówienia',
            netPrice: 'Cena netto sprzedaży',
            valuation: 'Koszt materiałów',
            plannedSendDate: 'Planowana data wysyłki',
            plannedDeliveryDate: 'Planowana data dostawy',
            receiveMaterialDate: 'Data dostawy surowca',
            receiveFileDate: 'Data dostarczenia plików',
            acceptFileDate: 'Data akceptacji plików',
            notesLabel: 'Uwagi do zamówienia',
            searchCustomerPlaceholder: 'Wpisz treść aby odnaleźć klienta.',
            searchCustomerMinLength: 'Wpisz przynajmniej {min} znaki.',
            searchCustomerLoading: 'Trwa wyszukiwanie klienta...',
            searchCustomerNotFound: 'Nie odnaleziono klienta na zapytanie: "{query}".',
            noData: 'Nie znaleziono',
            noProductsMessage: 'Nie wybrano produktów do zamówienia.',
            productsSectionTitle: 'Produkty',
            addProductTooltip: 'Dodaj produkt',
            configProductTooltip: 'Konfiguracja produktu',
            removeProductTooltip: 'Usuń',
            commentsSectionTitle: 'Komentarze do zamówienia',
            noCommentsMessage: 'Brak komentarzy.',
            addCommentButton: 'Dodaj',
            adviceNoteButton: 'Awizacja od klienta',
            cancelButton: 'Anuluj',
            createButton: 'Utwórz',
            deliveryPlanLabel: 'Plan dostaw',
            graphicFileDeliveryMethodLabel: 'Metoda dostarczenia plików graficznych',
            validation: {
                invalidMessage: 'Proszę wypełnić poprawnie wymagane pola.',
                nameRequired: 'Proszę podać nazwę zamówienia.',
                nameMaxLength: 'Nazwa nie może być dłuższa niż 100 znaków',
                nameIllegalChars: 'Niedozwolone znaki – {chars}',
                customerRequired: 'Proszę wybrać klienta.',
                numberConfigurationTypeRequired: 'Proszę wybrać typ zamówienia.',
                graphicFileMethodRequiresProductionFiles: 'Metoda wymaga plików produkcyjnych w produktach.'
            },
            dialogs: {
                removeProduct: {
                    title: 'Usuwanie produktu',
                    content: 'Czy na pewno chcesz usunąć produkt?',
                    confirmButton: 'Usuń'
                }
            }
        },
        product: {
            parametersTitle: 'Parametry produktu',
            selectFromTemplate: 'Wybierz z szablonu',
            name: 'Nazwa produktu',
            productType: 'Rodzaj produktu',
            width: 'Szerokość',
            height: 'Wysokość',
            amount: 'Nakład',
            weight: 'Waga',
            numberOfVersions: 'Ilość wzorów',
            signalProduct: 'Sygnalne produktu',
            signalAmount: 'Ilość',
            destinyPaper: 'Rodzaj papieru docelowej produkcji',
            notes: 'Uwagi',
            productionFilePath: 'Ścieżka pliku produkcyjnego',
            saveAsTemplate: 'Zapisz jako nowy szablon',
            productionFiles: 'Pliki produkcyjne',
            productionFileName: 'Nazwa pliku / link',
            componentsTitle: 'Komponenty',
            addComponent: 'Dodaj komponent',
            noComponents: 'Produkt nie posiada przypisanych komponentów.',
            addProductionProperties: 'Dodaj cechy produkcyjne',
            addProductionProcesses: 'Dodaj procesy produkcyjne',
            back: 'Wstecz',
            save: 'Zapisz',
            noProductionFiles: 'Nie dodano pliku produkcyjnego.',
            numberOfSignatures: 'Liczba składek',
            numberOfSignaturesPlaceholder: 'Podaj liczbę składek',
            signatureRangeEmpty: 'Składki: -',
            signatureRange: 'Składki: {start} - {end}',
            noProductionProperties: 'Brak przypisanych cech produkcyjnych.',
            noProductionProcesses: 'Brak przypisanych procesów produkcyjnych.',
            productionPropertiesLabel: 'Cechy produkcyjne:',
            productionProcessesLabel: 'Procesy produkcyjne:',
            removeProperty: 'Usuń cechę',
            valuePlaceholder: 'wartość',
            copyComponent: 'Kopiuj komponent',
            productionFileUploadLabel: 'Wgraj plik do systemu',
            productionFileInputLabel: 'Plik produkcyjny',
            productionFileInputPlaceholder: 'Wybierz plik',
            productionFileInputHint: 'Wymagany plik PDF. Dozwolone znaki: A-Z, 0-9, - oraz _',
            productionFileUploadSubmit: 'Wyślij',
            productionFileLinkLabel: 'Podaj link do pliku produkcyjnego',
            productionFileLinkFieldLabel: 'Link do pliku',
            productionFileLinkPlaceholder: 'Wklej link do plików',
            productionFileSizeLimit: 'Dopuszczalny rozmiar pojedynczego pliku: {max} MB',
            removeProductionFile: 'Usuń',
            validations: {
                formInvalid: 'Formularz jest nieprawidłowo wypełniony.',
                requiredField: 'Pole wymagane',
                noComponents: 'Produkt musi posiadać co najmniej jeden komponent.',
                productionFileSize: 'Przekroczono dopuszczalny rozmiar pliku: {max} MB.',
                nameRequired: 'Nazwa produktu jest wymagana.',
                productTypeRequired: 'Rodzaj produktu jest wymagany.',
                amountMin: 'Nakład musi być liczbą nie mniejszą niż 1.',
                invalidValue: 'Nieprawidłowa wartość.',
                numberOfVersionsMin: 'Ilość wzorów musi być nie mniejsza niż 1.',
                componentProcessesRequired: 'Każdy komponent musi posiadać co najmniej jeden proces produkcyjny.',
                propertyValueRequired: 'Wszystkie cechy produkcyjne muszą mieć uzupełnioną wartość.',
                propertyValueRequiredInline: 'Proszę podać wartość.',
                signatureCopiesMin: 'Liczba składek musi być liczbą nie mniejszą niż 1.',
                destinyPaperRequired: 'Dla produktu z proof wymagany jest rodzaj papieru docelowej produkcji.',
                signalAmountMin: 'Ilość sygnalna musi być nie mniejsza niż 1.',
                productsInSetCombination: 'Nie można łączyć kompletowanego produktu z innymi.'
            },
            dialogs: {
                removeComponent: {
                    title: 'Usunąć komponent z produktu?',
                    content: 'Czy na pewno chcesz usunąć komponent?'
                },
                leavePage: {
                    title: 'Opuścić stronę?',
                    content: 'Szablon produktu nie został zapisany. Czy chcesz opuścić stronę?'
                }
            }
        },
        sendingParametersDialog: {
            title: 'Edycja rodzaju wysyłki',
            transport: 'Transport',
            distance: 'Dystans',
            km: 'km',
            calculateCost: 'Oblicz koszt wysyłki',
            cost: 'Koszt',
            costSuffix: 'zł',
            cancel: 'Anuluj',
            save: 'Zapisz',
            costValidationError: 'Maksymalnie 2 cyfry po przecinku'
        },
        assignProductTemplateDialog: {
            title: 'Znajdź szablon produktu',
            productTemplate: 'Szablon produktu',
            cancel: 'Anuluj',
            save: 'Zapisz'
        },
        service: {
            fetchOrdersError: 'Pobranie listy zamówień nie powiodło się.',
            fetchOrderError: 'Pobranie informacji o zamówieniu nie powiodło się.',
            updateOrderError: 'Aktualizacja zamówienia nie powiodła się.',
            deleteOrderError: 'Usunięcie zamówienia nie powiodło się.',
            createOrderError: 'Złożenie zamówienia nie powiodło się.',
            copyOrderError: 'Kopiowanie zamówienia nie powiodło się.',
            createOrderSuccess: 'Zamówienie zostało złożone.',
            createDeliveryAttachmentError: 'Dodanie planu dostaw nie powiodło się.',
            createJobError: 'Utworzenie zlecenia nie powiodło się.',
            createJobSuccess: 'Zlecenie zostało utworzone.',
            fetchStatusesError: 'Pobranie statusów nie powiodło się.',
            fetchNumberConfigurationTypesError: 'Pobranie typów numeracji zamówienia nie powiodło się.',
            addCommentSuccess: 'Dodano komentarz.',
            addCommentError: 'Dodanie komentarza nie powiodło się.'
        }
    },
    nonStandard: {
        menuTitle: 'Niestandardowe',
        pageTitle: 'Zamówienia / Zamówienia niestandardowe',
        list: {
            pageTitle: 'Lista zamówień niestandardowych',
            sendToday: 'Wysyłka na dziś',
            search: 'Szukaj...',
            orderNumber: 'Numer zamówienia',
            productName: 'Nazwa produktu',
            customer: 'Klient',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            amount: 'Nakład',
            status: 'Status',
            actions: 'Akcje',
            overdue: 'Opóźnione',
            open: 'Otwórz'
        },
        service: {
            fetchOrdersError: 'Pobranie listy zamówień nie powiodło się.',
            fetchOrderError: 'Pobranie informacji o zamówieniu nie powiodło się.',
            fetchStatusesError: 'Pobranie statusów nie powiodło się.'
        }
    },
    cooperant: {
        complaintOrder: 'Zamówienie reklamacyjne',
        menuTitle: 'Kooperacja',
        pageTitle: 'Zamówienia / Kooperacja',
        orderPageTitle: 'Zamówienia / Kooperacja / Zamówienie',
        list: {
            pageTitle: 'Lista zamówień',
            withCooperantNumber: 'Z numerem kooperanta',
            sendDateFrom: 'Data wysyłki od',
            sendDateTo: 'Data wysyłki do',
            search: 'Szukaj...',
            generateReport: 'Generuj raport',
            orderNumber: 'Numer zamówienia',
            cooperantNumber: 'Numer zamówienia kooperanta',
            shopName: 'Nazwa sklepu',
            invoice: 'Faktura',
            productName: 'Nazwa produktu',
            quantity: 'Nakład',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            cod: 'COD',
            status: 'Status',
            actions: 'Akcje',
            overdue: 'Opóźnione',
            open: 'Otwórz',
            delete: 'Usuń zamówienie',
            deleteOrderTitle: 'Usuwanie zamówienia',
            deleteOrderContent: 'Czy na pewno chcesz usunąć to zamówienie?'
        },
        order: {
            backToList: 'Powrót do listy',
            orderTitle: 'Zamówienie',
            overdue: 'opóźnione',
            orderParameters: 'Parametry zamówienia',
            orderDescription: 'Opis zamówienia',
            shopName: 'Nazwa sklepu',
            invoice: 'Faktura',
            cooperantNumber: 'Numer zamówienia kooperanta',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            cod: 'COD',
            yes: 'Tak',
            no: 'Nie',
            product: 'Produkt',
            quantity: 'Nakład',
            productCode: 'Kod produktu',
            cooperantPrice: 'Cena kooperanta',
            unit: 'szt.',
            currency: 'zł',
            multiPatternDetails: 'Szczegóły zamówienia wielowzorowego',
            nameOrColor: 'Nazwa lub kolor',
            amount: 'Ilość',
            code: 'Kod',
            shippingAddresses: 'Adresy do wysyłki',
            address: 'Adres',
            sender: 'Nadawca',
            patternsCount: 'Ilość wzorów',
            weight: 'Waga przesyłki',
            parcelsCount: 'Ilość kartonów',
            status: 'Status',
            actions: 'Akcje',
            editParcels: 'Edytuj kartony',
            sendManually: 'Nadaj ręcznie',
            generateLabel: 'Generuj etykietę',
            pattern: 'Wzór',
            filePreview: 'Podgląd plików',
            productionFiles: 'Pliki produkcyjne',
            downloadProductionFiles: 'Pobranie plików produkcyjnych',
            comments: 'Komentarze do zamówienia',
            noComments: 'Brak komentarzy do zamówienia.',
            addComment: 'Dodaj komentarz',
            sendComment: 'Wyślij',
            send: 'Wyślij',
            save: 'Zapisz',
            close: 'Zamknij'
        },
        mockup: {
            title: 'Makieta',
            add: 'Dodaj makietę',
            downloadMockup: 'Pobierz makietę',
            delete: 'Usuń makietę',
            deleteConfirm: 'Czy na pewno chcesz usunąć makietę?',
            imageAlt: 'Makieta',
            statusWithValue: 'Status: {status}',
            rejectReasonWithValue: 'Powód odrzucenia: {reason}',
            invalidFileType: 'System obsługuje tylko pliki JPG',
            fileTooLarge: 'Maksymalna waga pliku nie może przekroczyć 15MB',
            uploadSuccess: 'Makieta została wgrana.',
            uploadError: 'Wgranie makiety nie powiodło się.',
            deleteSuccess: 'Makieta została usunięta.',
            deleteError: 'Usunięcie makiety nie powiodło się.',
            waitingForNewVisualization:
                'Wizualizacja została odrzucona. Dodawanie makiet będzie możliwe po otrzymaniu nowej wizualizacji.'
        },
        dialogs: {
            sentManually: {
                title: 'Wpisz numer listu przewozowego',
                label: 'Numer listu',
                cancel: 'Anuluj',
                save: 'Zapisz',
                validationError: 'Dozwolone znaki: cyfry i litery (bez polskich znaków)'
            }
        },
        service: {
            fetchOrdersError: 'Pobranie listy zamówień nie powiodło się.',
            fetchOrderError: 'Pobranie informacji o zamówieniu nie powiodło się.',
            fetchDeliveryStatusesError: 'Pobranie statusów dostaw nie powiodło się.',
            fetchOrderStatusesError: 'Pobranie statusów zamówień nie powiodło się.',
            fetchOrdersByNumbersError: 'Pobranie zamówień zlecenia nie powiodło się.',
            addCommentSuccess: 'Dodano komentarz.',
            addCommentError: 'Dodanie komentarza nie powiodło się.',
            generateReportSuccess: 'Po wygenerowaniu raport zostanie wysłany na adres {email}.',
            generateReportError: 'Wygenerowanie raportu nie powiodło się.',
            printLabelsSuccess: 'Wygenerowano etykiety przewozowe.',
            printLabelsError: 'Wygenerowanie etykiet przewozowych nie powiodło się.',
            provideDeliveryNumberSuccess: 'Numer listu przewozowego został dodany.',
            provideDeliveryNumberError: 'Dodanie numeru listu przewozowego nie powiodło się.',
            updateOrderError: 'Aktualizacja zamówienia nie powiodła się.',
            updateDeliveryError: 'Edycja dostawy nie powiodła się.',
            deleteOrderSuccess: 'Zamówienie zostało usunięte.',
            deleteOrderError: 'Zamówienie nie mogło zostać usunięte',
            toolboxError: 'Błąd komunikacji z Toolboxem.'
        }
    },
    wmd: {
        menuTitle: 'WMD',
        pageTitle: 'Zamówienia / WMD',
        orderPageTitle: 'Zamówienia / WMD / Zamówienie',
        list: {
            pageTitle: 'Lista zamówień WMD',
            sendToProduction: 'Do realizacji',
            maxSelectedError: 'Można wybrać maksymalnie 30 zamówień.',
            refresh: 'Odśwież',
            clearFilters: 'Wyczyść filtry',
            complaintsOnly: 'Zamówienia reklamacyjne',
            productType: 'Typ produktu',
            searchOrder: 'Szukaj zamówienia...',
            statusesPlaceholder: 'Wybierz status...',
            statusesNoData: 'Brak danych...',
            orderDateFrom: 'Data zamówienia od',
            orderDateTo: 'Data zamówienia do',
            sendDateFrom: 'Wysyłka od',
            sendDateTo: 'Wysyłka do',
            customerNumber: 'Numer Klienta',
            orderNumber: 'Numer zamówienia',
            productName: 'Nazwa produktu',
            amount: 'Nakład',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            deliveryDate: 'Data dostawy',
            status: 'Status',
            actions: 'Akcje',
            overdue: 'Opóźnione',
            missingPattern: 'Brak wymaganej makiety',
            submitOrder: 'Złóż zamówienie',
            cancelOrder: 'Anuluj zamówienie',
            open: 'Otwórz',
            addComment: 'Dodaj komentarz',
            reloadOrder: 'Odśwież zamówienie',
            removeOrder: 'Usuń',
            removeOrderTitle: 'Usuwanie zamówienia',
            removeOrderContent: 'Czy na pewno chcesz usunąć zamówienie?',
            reloadOrderTitle: 'Odświeżanie zamówienia',
            reloadOrderContent: 'Czy na pewno chcesz wgrać zamówienie ponownie?'
        },
        order: {
            backToList: 'Powrót do listy',
            orderTitle: 'Zamówienie',
            overdue: 'opóźnione',
            submitOrder: 'Złóż zamówienie',
            setStatus: 'Ustaw status',
            cancelOrderTitle: 'Anulowanie zamówienia',
            cancelOrderContent: 'Czy na pewno chcesz anulować zamówienie?',
            removeOrderTitle: 'Usuwanie zamówienia',
            removeOrderContent: 'Czy na pewno chcesz usunąć zamówienie?',
            complaintOrder: 'Zamówienie reklamacyjne',
            priority: 'Priorytet',
            reportComplaint: 'Zgłoś reklamację',
            lieferschein: 'Lieferschein',
            orderParameters: 'Parametry zamówienia',
            customerNumber: 'Numer Klienta',
            orderNumber: 'Numer zamówienia',
            shopName: 'Nazwa sklepu',
            orderDate: 'Data zamówienia',
            plannedSendDate: 'Planowana data wysyłki',
            deliveryDate: 'Data dostawy',
            productName: 'Nazwa produktu',
            amount: 'Nakład',
            unit: 'szt.',
            multiAddress: 'Wysyłki wieloadresowe',
            code: 'Kod',
            address: 'Adres',
            patternsCount: 'Ilość wzorów',
            carrier: 'Kurier',
            weight: 'Waga przesyłki',
            numberOfPackages: 'Liczba kartonów',
            filesPreview: 'Preflight',
            productionFiles: 'Pliki produkcyjne',
            componentWithoutName: 'Bez nazwy',
            productionFileDefault: 'Plik produkcyjny',
            noPreviews: 'Brak podglądów',
            comments: 'Komentarze do zamówienia',
            noComments: 'Brak komentarzy do zamówienia.',
            addComment: 'Dodaj komentarz',
            sendComment: 'Wyślij',
            close: 'Zamknij'
        },
        dialogs: {
            addComment: {
                title: 'Komentarz do zamówienia {orderNumber}',
                commentLabel: 'Dodaj komentarz',
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            notSentOrders: {
                title: 'Numery zamówień, których nie udało się dodać',
                orderNumber: 'Numer zamówienia',
                customerNumber: 'Numer Klienta',
                status: 'Status',
                close: 'Zamknij'
            }
        },
        service: {
            fetchOrdersError: 'Pobranie listy zamówień nie powiodło się.',
            fetchOrderError: 'Pobranie informacji o zamówieniu nie powiodło się.',
            fetchLieferscheinError: 'Nie udało się pobrać dokumentu Lieferschein.',
            refreshOrdersError: 'Odświeżanie listy zamówień nie powiodło się.',
            fetchStatusesError: 'Pobranie statusów nie powiodło się.',
            fetchProductTypesError: 'Pobranie listy typów produktów nie powiodło się.',
            acceptOrderSuccess: 'Zamówienie zostało złożone.',
            acceptOrderError: 'Złożenie zamówienia nie powiodło się.',
            cancelOrderSuccess: 'Zamówienie zostało anulowane.',
            cancelOrderError: 'Anulowanie zamówienia nie powiodło się.',
            removeOrderSuccess: 'Zamówienie zostało usunięte.',
            removeOrderError: 'Usunięcie zamówienia nie powiodło się.',
            deleteOrderSuccess: 'Zamówienie zostało odświeżone.',
            deleteOrderError: 'Odświeżenie zamówienia nie powiodło się.',
            updateOrderSuccess: 'Dane zostały zapisane.',
            updateOrderError: 'Aktualizacja zamówienia nie powiodła się.',
            sendToProductionSuccess: 'Zamówienia wysłane.',
            sendToProductionError: 'Wysłanie zamówień nie powiodło się.',
            addCommentSuccess: 'Dodano komentarz.',
            addCommentError: 'Dodanie komentarza nie powiodło się.',
            updateDeliveryError: 'Edycja dostawy nie powiodła się.'
        }
    },
    productComponents: {
        missingName: 'Brak tłumaczenia nazwy',
        fetchError: 'Pobranie tłumaczeń nazw komponentów nie powiodło się.'
    },
    productTemplates: {
        menuTitle: 'Szablony produktowe',
        pageTitle: 'Konfigurator produktów / Szablony produktowe',
        createPageTitle: 'Szablony produktowe / Nowy szablon produktu',
        editPageTitle: 'Szablony produktowe / Edycja szablonu produktu / {name}',
        actions: {
            add: 'Dodaj szablon produktu',
            save: 'Zapisz',
            backToList: 'Powrót do listy',
            addProductionProperties: 'Dodaj cechy produkcyjne',
            addProductionProcesses: 'Dodaj procesy produkcyjne'
        },
        filters: {
            name: 'Nazwa...'
        },
        table: {
            columns: {
                name: 'Nazwa',
                actions: 'Akcje'
            }
        },
        tooltips: {
            edit: 'Edytuj',
            copy: 'Kopiuj',
            delete: 'Usuń',
            copyComponent: 'Skopiuj komponent',
            removeComponent: 'Usuń komponent'
        },
        buttons: {
            removeParameter: 'Usuń parametr'
        },
        sections: {
            templateParameters: 'Parametry szablonu',
            components: 'Komponenty',
            productionProperties: 'Cechy produkcyjne',
            productionProcesses: 'Procesy produkcyjne'
        },
        form: {
            name: 'Nazwa szablonu',
            productType: 'Rodzaj produktu',
            width: 'Szerokość',
            height: 'Wysokość',
            defaultNotes: 'Domyślne uwagi',
            tag: 'Tag',
            productionFilePath: 'Ścieżka pliku produkcyjnego',
            valuePlaceholder: 'wartość',
            noDataText: 'Nie znaleziono'
        },
        messages: {
            noComponents: 'Produkt nie posiada przypisanych komponentów.',
            noProductionProperties: 'Brak przypisanych cech produkcyjnych.',
            noProductionProcesses: 'Brak przypisanych procesów produkcyjnych.'
        },
        validations: {
            nameRequired: 'Proszę podać nazwę produktu.',
            productTypeRequired: 'Proszę podać rodzaj produktu.',
            tagMaxLength: 'Tag nie może przekroczyć {max} znaków.',
            invalidValue: 'Nieprawidłowa wartość.',
            valueRequired: 'Proszę podać wartość.'
        },
        dialogs: {
            delete: {
                title: 'Usuwanie szablonu produktu',
                content: 'Czy na pewno chcesz usunąć szablon produktu?',
                confirm: 'Usuń'
            },
            removeComponent: {
                title: 'Usunąć komponent z produktu?',
                content: 'Czy na pewno chcesz usunąć komponent?'
            },
            leave: {
                title: 'Opuścić stronę?',
                content: 'Szablon produktu nie został zapisany. Czy chcesz opuścić stronę?'
            }
        },
        service: {
            fetchProductTemplatesError: 'Pobranie listy szablonów produktowych nie powiodło się.',
            fetchProductTemplateError: 'Pobranie danych do szablonu produktowego nie powiodło się.',
            createProductTemplateSuccess: 'Szablon produktu został dodany.',
            createProductTemplateError: 'Dodanie szablonu produktu nie powiodło się.',
            updateProductTemplateSuccess: 'Szablon produktowy został zedytowany.',
            updateProductTemplateError: 'Edycja szablonu produktu nie powiodła się.',
            deleteProductTemplateSuccess: 'Szablon produktu został usunięty.',
            deleteProductTemplateError: 'Usunięcie szablonu produktu nie powiodło się.',
            fetchProductionFileInPathsError: 'Pobranie ścieżek plików produkcyjnych nie powiodło się.',
            fetchFoldingTypesError: 'Pobranie typów składania nie powiodło się.'
        }
    }
}

export default {
    messages
}
